import {
    Box,
    Link,
    FontAwesomeIcon,
    faSquarePlus,
    ReactHtmlParser,
    Typography,
    SpanTypography
} from "@/src/components/journal-site/articles/article-meta-data"
import NextLink from "next/link";

const EicNotes = ({eicNotes}: {eicNotes: any}) => (
    <Box role="doc-afterword" mt={2}>
        <Typography component="b" id="eicNotes">
            <Link component={NextLink} href="#eicNotes" underline="none" display="flex" alignItems="center">
                <SpanTypography color="default">
                    <FontAwesomeIcon icon={faSquarePlus} />
                </SpanTypography>
                <SpanTypography component="span" ml={1}>
                    EIC Notes
                </SpanTypography>
            </Link>
        </Typography>
        {
            eicNotes.map((note: { note: string }, index: number) => (
                <Box key={`note-${index}`} sx={{ display: "none" }}>
                    <Typography>
                        {
                            ReactHtmlParser(
                                note?.note || ''
                            )
                        }
                    </Typography>
                </Box>
            ))
        }
    </Box>
)

export default EicNotes;
